import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteUserDocument } from './delete.generated';

export const useDeleteUser = (options: ApiOptions<typeof DeleteUserDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteUserDocument, {
    ...useNotifications(DeleteUserDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.users.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteUser?.user == null) return;
      cache.evict({ id: cache.identify(data.deleteUser.user) });
    },

    ...options,
  });
};
